import { Button, Card, Form, InputNumber } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  buttonLabel,
  cardConfig,
  formConfig,
  masks,
  messages,
} from '../../../../constants';
import { useEffect, useState } from 'react';
import { updateConfigs } from '../../../../appRedux/actions';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { MaskedInput } from 'antd-mask-input';
import { formatNumber } from '../../../../util/api/formatNumber';
import { commissionError } from '../../../../constants/Commissions.const';

export const SettingComissionRateModal = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const { configs } = useSelector((state) => state.configs);
  const [form] = Form.useForm();
  const { setShowModal } = useCustomModal();

  const [isLoading, setIsLoading] = useState(false);
  const [configId, setConfigId] = useState();
  const [response, setResponse] = useState();

  useEffect(() => {
    setConfigId(configs?.id);
  }, [configs?.id]);

  useEffect(() => {
    if ([200, 201].includes(response)) {
      setShowModal(false);
      if (onSuccess) onSuccess();
    }
  }, [response, setShowModal, onSuccess]);

  const validateMinLessThanMax = (fieldIndex) =>
    ({ getFieldValue }) => ({
      validator(_, value) {
        const min = getFieldValue([
          'comissionRate',
          fieldIndex,
          'min',
        ]);

        if (
          min === undefined ||
          min === '' ||
          value === undefined ||
          value === ''
        ) {
          return Promise.resolve();
        }

        if (Number(value) <= Number(min)) {
          return Promise.reject(
            new Error(commissionError.MIN_LESS_THAN_MAX)
          );
        }

        return Promise.resolve();
      },
    });

  useEffect(() => {
    const pairs = configs?.comissionRate;

    if (pairs && Array.isArray(pairs) && pairs.length) {
      form.setFieldsValue({
        comissionRate: pairs.map((item) => ({
          percentage:
            item?.percentage != null ? formatNumber(item.percentage) : '',
          min: item?.min ?? '',
          max: item?.max ?? '',
        })),
      });
    } else {
      form.setFieldsValue({
        comissionRate: [{ percentage: '', min: '', max: '' }],
      });
    }
  }, [configs, form]);

  const onSubmit = async (values) => {
    const payload = {
      comissionRate: (values?.comissionRate || []).map((row) => ({
        percentage: row?.percentage ? parseFloat(row.percentage) : 0,
        min: row?.min ?? 0,
        max: row?.max ?? 0,
      })),
    };

    setIsLoading(true);

    if (configId) {
      setResponse(await dispatch(updateConfigs(configId, payload)));
    }

    setIsLoading(false);
  };

  return (
    <Card size="small" bordered={true} style={cardConfig}>
      <Form autoComplete="off" onFinish={onSubmit} form={form} {...formConfig}>
        <Form.List name="comissionRate">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <div
                  key={field.key}
                  style={{
                    display: 'flex',
                    gap: 12,
                    alignItems: 'flex-start',
                    marginBottom: 12,
                  }}
                >
                  <Form.Item
                    name={[field.name, 'percentage']}
                    label="Porcentaje"
                    style={{ flex: 1.5 }}
                    rules={[
                      {
                        required: true,
                        message: messages.required('Porcentaje'),
                      },
                    ]}
                  >
                    <MaskedInput mask={masks.numPercent} />
                  </Form.Item>

                  <Form.Item
                    name={[field.name, 'min']}
                    label="Min"
                    style={{ flex: 0.6 }}
                    rules={[
                      { required: true, message: messages.required('Mínimo') },
                    ]}
                  >
                    <InputNumber />
                  </Form.Item>

                  <Form.Item
                    name={[field.name, 'max']}
                    label="Max"
                    style={{ flex: 0.6 }}
                    rules={[
                      { required: true, message: messages.required('Máximo') },
                      validateMinLessThanMax(field.name),
                    ]}
                  >
                    <InputNumber />
                  </Form.Item>

                  {fields.length > 1 && (
                    <Button
                      danger
                      type="text"
                      style={{ marginTop: 30 }}
                      icon={<MinusCircleOutlined />}
                      onClick={() => remove(field.name)}
                    />
                  )}
                </div>
              ))}

              <Button
                type="dashed"
                onClick={() => add({ percentage: '', min: '', max: '' })}
                icon={<PlusOutlined />}
                block
                style={{ marginBottom: 16 }}
              >
                {buttonLabel.add}
              </Button>
            </>
          )}
        </Form.List>

        <Button
          type="primary"
          htmlType="submit"
          className="btn-form"
          loading={isLoading}
        >
          {buttonLabel.save}
        </Button>
      </Form>
    </Card>
  );
};
